function showMenu(details, content) {
  var currentOpacity = window.getComputedStyle(content).getPropertyValue('opacity') || 0;  // initial opacity
  details.setAttribute('open', true);
  if (currentOpacity >= 1) {
    return;
  }
  if (content.hideAnimation) content.hideAnimation.cancel();
  const animation = content.animate(
    { opacity: [currentOpacity, 1] },
    { duration: 250, easing: 'cubic-bezier(0.42, 0, 0.58, 1)' }
  );
  content.showAnimation = animation;
}

function hideMenu(details, content) {
  var currentOpacity = window.getComputedStyle(content).getPropertyValue('opacity') || 0;  // initial opacity
  if (currentOpacity <= 0) {
    details.removeAttribute('open');
    return;
  }
  if (content.showAnimation) content.showAnimation.cancel();
  const animation = content.animate(
    { opacity: [currentOpacity, 0] },
    { duration: 250, easing: 'cubic-bezier(0.42, 0, 0.58, 1)' }
  );
  content.hideAnimation = animation;
  animation.onfinish = function() {
    details.removeAttribute('open');
  };
}

function createBeforeElement(item, detailsElement) {
  const beforeElement = document.createElement('div');
  beforeElement.style.display = 'block';
  beforeElement.style.position = 'absolute';
  beforeElement.style.top = '0';
  beforeElement.style.width = window.getComputedStyle(detailsElement).getPropertyValue('width');
  beforeElement.style.height = '100%';

  item.insertBefore(beforeElement, item.firstChild);
  item.beforeElement = beforeElement;
}

const menuItems = document.querySelectorAll('.header__inline-menu > ul > li');
let activeMenuItem = null; 
menuItems.forEach((item, index) => {
  const detailsElement = item.querySelector('details');
  const contentElement = detailsElement?.querySelector('.mega-menu__content');
  if (!contentElement) {
    return;
  }
  item.setAttribute('menu-item-width', window.getComputedStyle(detailsElement).getPropertyValue('width'))
  const beforeElement = window.getComputedStyle(item, '::before');
  
  item.addEventListener('mouseenter', () => {
    if (activeMenuItem && activeMenuItem !== item) {
      const previousDetailsElement = activeMenuItem.querySelector('details');
      const previousContentElement = previousDetailsElement?.querySelector('.mega-menu__content');
      if (previousContentElement) {
        previousDetailsElement.removeAttribute('open');
      }
    }
    createBeforeElement(item, detailsElement);
    showMenu(detailsElement, contentElement);
    activeMenuItem = item; 
  });

  item.addEventListener('mouseleave', () => {
    setTimeout(() => {
      if (!item.matches(':hover')) {
        item.removeChild(item.beforeElement);
        hideMenu(detailsElement, contentElement);
        if (activeMenuItem === item) activeMenuItem = null; 
      } 
    }, 20); // Adjust delay as needed
  });
});
